export const homeConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getOneClickActionDetails_request: "getOneClickActionDetails_request",
        getOneClickActionDetails_success: "getOneClickActionDetails_success",
        getOneClickActionDetails_failure: "getOneClickActionDetails_failure",
    
        getInvoiceDetailList_request: "getInvoiceDetailList_request",
        getInvoiceDetailList_success: "getInvoiceDetailList_success",
        getInvoiceDetailList_failure: "getInvoiceDetailList_failure",
        
        generateAllUnbilledInvoices_request: "generateAllUnbilledInvoices_request",
        generateAllUnbilledInvoices_success: "generateAllUnbilledInvoices_success",
        generateAllUnbilledInvoices_failure: "generateAllUnbilledInvoices_failure",

        generateAllUnbilledAdvancePayInvoices_request: "generateAllUnbilledAdvancePayInvoices_request",
        generateAllUnbilledAdvancePayInvoices_success: "generateAllUnbilledAdvancePayInvoices_success",
        generateAllUnbilledAdvancePayInvoices_failure: "generateAllUnbilledAdvancePayInvoices_failure",

        postAllUnpostedInvoicesToSqlAccount_request: "postAllUnpostedInvoicesToSqlAccount_request",
        postAllUnpostedInvoicesToSqlAccount_success: "postAllUnpostedInvoicesToSqlAccount_success",
        postAllUnpostedInvoicesToSqlAccount_failure: "postAllUnpostedInvoicesToSqlAccount_failure",

        sendAllPendingInvoices_request: "sendAllPendingInvoices_request",
        sendAllPendingInvoices_success: "sendAllPendingInvoices_success",
        sendAllPendingInvoices_failure: "sendAllPendingInvoices_failure",
        
        generateCompareUnpostedInvoices_request: "generateCompareUnpostedInvoices_request",
        generateCompareUnpostedInvoices_success: "generateCompareUnpostedInvoices_success",
        generateCompareUnpostedInvoices_failure: "generateCompareUnpostedInvoices_failure",
    }

    let obj_formatted = {};
    let domain = "billingPortal.home/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}